import React from 'react';

import './AccessibleFeatureSection.scss';
import AccessServiceBadge from '../AccessServiceBadge';
import { TAccessServiceType } from '../../@types/Access';
import AccessCTACard from '../AccessCTACard/AccessCTACard';

export interface IAccessibleFeatureSectionProps {
  accessibleFeatures: TAccessServiceType[];
  mediaType: 'movie' | 'series';
}

const AccessibleFeatureSection = ({
  accessibleFeatures,
  mediaType,
}: IAccessibleFeatureSectionProps) => {
  const accessibleFeatureItems = accessibleFeatures.map((accessibleFeature) => (
    <li key={accessibleFeature} className="accessible-feature">
      <AccessServiceBadge type={accessibleFeature} />
    </li>
  ));

  const isSeries = mediaType === 'series';
  const isMovie = mediaType === 'movie';

  return (
    <div className="accessible-feature-section">
      <h3 className="accessible-feature-section__title">
        Accessible Features{isSeries ? '*' : ''}
      </h3>
      <ul className="accessible-feature-section__accessible-feature-list">
        {accessibleFeatureItems}
      </ul>
      <AccessCTACard />
      {isSeries && (
        <p className="accessible-feature-section__note">
          *Availability may vary by episode
        </p>
      )}
    </div>
  );
};

export default AccessibleFeatureSection;
